"use client";

import { ReactNode, useId, useState } from "react";
import { TabBar, tabPanelProps } from "./tab-bar";

export type TabbedPanel = {
  value: string;
  label: ReactNode;
  /** Rendered on the server; inactive panels stay in the DOM but hidden. */
  content: ReactNode;
};

type Props = {
  panels: TabbedPanel[];
  className?: string;
};

/** Tabs whose panels are all rendered up front, so switching needs no fetch. */
const TabbedPanels = ({ panels, className }: Props) => {
  const [selected, setSelected] = useState(panels[0]?.value);
  const idPrefix = useId().replace(/:/g, "");

  if (!panels.length) return null;

  // Panelerna kan bytas ut vid en router refresh (t.ex. Börsnytt → Senaste nytt
  // när börstiden passeras). Faller valet bort, visa första panelen.
  const active = panels.some((p) => p.value === selected)
    ? selected
    : panels[0].value;

  return (
    <div className={className}>
      <TabBar
        tabs={panels.map(({ value, label }) => ({ value, label }))}
        active={active}
        onChange={setSelected}
        idPrefix={idPrefix}
      />
      {panels.map((panel) => (
        <div key={panel.value} {...tabPanelProps(idPrefix, panel.value, active)}>
          {panel.content}
        </div>
      ))}
    </div>
  );
};

export default TabbedPanels;
